import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { UserSkillLibraryActions } from '@/user-skills/store/library.slice'
import { useUserSkillMutations } from './useUserSkillMutations'

export type UserSkillsLibrary = ReturnType<typeof useUserSkills>

export function useUserSkills() {
  const dispatch = useAppDispatch()
  const library = useAppSelector((state) => state.userSkillLibraryState)
  const mutations = useUserSkillMutations()
  useEffect(() => {
    dispatch(UserSkillLibraryActions.refreshLibrary({ force: false }))
  }, [dispatch])

  const refresh = () => dispatch(UserSkillLibraryActions.refreshLibrary({ force: true }))
  const loading = library.loading || (!library.loaded && !library.loadError)
  return { skills: library.skills, paxtonSkills: library.paxtonSkills, loading, loadError: library.loadError, refresh, ...mutations }
}
